import { Box, Button, Divider, Typography } from "@mui/material"
import CustomDialog from "components/Dialogs/MasterDialog"
import { CommonTexts, messagesTexts } from "locale/es"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { deleteMessageAction } from "redux/reducers/messagesReducer"
import { AppColors } from "resources/AppColors"

function DeleteMessageDialog() {
  const { entityId } = useLocation().state

  const navigate = useNavigate()

  const dispatch = useDispatch()

  function handleOnConfirmDeleteMessage() {
    dispatch(deleteMessageAction(entityId))
    handleShowExitModal()
  };

  function handleShowExitModal() {
    navigate('/missatges')
  }

  return (
    <CustomDialog
      title={messagesTexts.DELETED_TITLE}
      show={true}
      handleShow={handleShowExitModal}
    >
      <Divider />
      <Box py={2} px={3} sx={{ minWidth: "50%" }}>
        <Typography variant="body">
          {messagesTexts.DELETED_CONFIRM}
        </Typography>
      </Box>
      <Divider />
      <Box display="flex" justifyContent="flex-end" p={1}>
        <Button
          style={{ backgroundColor: AppColors.RED }}
          color="primary"
          variant="contained"
          onClick={handleOnConfirmDeleteMessage}
          data-cy="submit-delete-message-button"
        >
          {CommonTexts.DELETE}
        </Button>
      </Box>
    </CustomDialog>
  )
}

export default DeleteMessageDialog